import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ProvisionHeader } from 'src/models/provisionheader';

@Pipe({
  standalone: false,
  name: 'filterByProvisionName'
})

@Injectable()
export class SearchProvisionHeader implements PipeTransform {
  transform(items: ProvisionHeader[], value: string): ProvisionHeader[] {
    if (!items) return [];
    if (items.length === 0) return [];
    if (value === '' || value === undefined) return items;

    items = items.filter(it => it.ProvisionName.toLowerCase().search(value.toLowerCase()) > -1);
    return items;
  }
}
